module.exports = function() {
  return this.data;
}



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/computed/table-data.js